import { notification } from 'antd';
export const notificationSuccess = (name?: string, msg?: string) => {
  return notification.success({
    message: `${name || ''}成功`,
    description: `${msg || ''}`,
    placement: 'topRight',
    style: { whiteSpace: 'pre-line' },
  });
};

export const notificationError = (name?: string, msg?: string) => {
  return notification.error({
    message: `${name || ''}失敗`,
    description: `${msg || ''}`,
    placement: 'topRight',
    duration: 0,
    style: { whiteSpace: 'pre-line' },
  });
};

export const notificationInfo = (name?: string, msg?: string) => {
  return notification.info({
    message: `${name || ''}`,
    description: `${msg || ''}`,
    placement: 'topRight',
    style: { whiteSpace: 'pre-line' },
  });
};
